import {isAnyOf} from '@reduxjs/toolkit'

import {getSaleHistoryDetailByApi} from '@web/actions/saleHistory'
import {APIStatus, PageSet} from '@web/core/constants'
import makeSlice from '@web/slices/common/sliceMaker'

import {initSaleHistory} from '../../actions/saleHistory'
import {initSaleHistoryDetail} from '../../actions/saleHistoryDetail'

const commonSlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(getSaleHistoryDetailByApi.pending, (state) => {
                state.pageSet = PageSet.SALE_HISTORY_DETAIL
                state.seqID = ''
            })
            .addCase(getSaleHistoryDetailByApi.fulfilled, (state, {payload}) => {
                state.seqID = payload.detail.order.orderNo
            })
            .addCase(initSaleHistory.pending, (state) => {
                state.pageSet = PageSet.SALE_HISTORY
            })
            .addMatcher(isAnyOf(initSaleHistory.pending, initSaleHistoryDetail.pending), (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addMatcher(isAnyOf(initSaleHistory.fulfilled, initSaleHistoryDetail.fulfilled), (state) => {
                state.scene = APIStatus.RESOLVED
            })
            .addMatcher(isAnyOf(initSaleHistory.rejected, initSaleHistoryDetail.rejected), (state) => {
                state.scene = APIStatus.REJECTED
            })
    },
})

export default commonSlice.reducer
